export default {"src":"/_next/static/media/eflLoader.f576db1c.gif","height":50,"width":90,"blurWidth":0,"blurHeight":0};